import { Reveal, Overline } from "./Reveal";

const PHOTOS = [
  { src: "/assets/team-1.webp", alt: "DSA team dispatching client orders with FedEx freight", span: "lg:col-span-7", h: "h-[420px] lg:h-[560px]" },
  { src: "/assets/team-2.webp", alt: "DSA team receiving a client shipment at the warehouse", span: "lg:col-span-5", h: "h-[300px] lg:h-[272px]" },
  { src: "/assets/team-3.webp", alt: "DSA team preparing client inventory on the operations floor", span: "lg:col-span-5", h: "h-[300px] lg:h-[272px]" },
];

export function TeamStrip() {
  return (
    <section data-testid="team-section" className="border-t border-black/10">
      <div className="mx-auto max-w-[1600px] px-5 py-32 md:px-10 md:py-48">
        <Reveal className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <Overline>The people behind it</Overline>
            <h2 className="mt-6 max-w-3xl font-display text-4xl font-black tracking-tighter sm:text-5xl lg:text-6xl">
              Real operators.{" "}
              <span className="text-ink/40">Real warehouse. Real inventory.</span>
            </h2>
          </div>
          <p className="max-w-sm font-body text-sm text-ink/50">
            The same team you'll work with for six months — on the floor, moving
            client product every day.
          </p>
        </Reveal>

        <div className="mt-20 grid grid-cols-1 gap-px bg-black/10 lg:grid-cols-12">
          <Reveal className="lg:col-span-7 lg:row-span-2 bg-white">
            <figure data-testid="team-photo-0" className="group relative h-[420px] overflow-hidden lg:h-[560px]">
              <img
                src={PHOTOS[0].src}
                alt={PHOTOS[0].alt}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <figcaption className="absolute bottom-4 left-4 bg-black/70 px-3 py-1.5 font-mono2 text-[10px] uppercase tracking-[0.2em] text-white backdrop-blur">
                Operations floor · FedEx freight dispatch
              </figcaption>
            </figure>
          </Reveal>
          {PHOTOS.slice(1).map((p, i) => (
            <Reveal key={p.src} delay={0.1 + i * 0.1} className="lg:col-span-5 bg-white">
              <figure data-testid={`team-photo-${i + 1}`} className="group relative h-[300px] overflow-hidden lg:h-[279px]">
                <img
                  src={p.src}
                  alt={p.alt}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <figcaption className="absolute bottom-4 left-4 bg-black/70 px-3 py-1.5 font-mono2 text-[10px] uppercase tracking-[0.2em] text-white backdrop-blur">
                  {i === 0 ? "Inbound · shipment receiving" : "Operations floor · daily client inventory"}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
